document.querySelectorAll('.slider.swiper').forEach((el) => {
    const delay = parseInt(el.dataset.delay || 6000, 10);
    const effect = el.dataset.effect || 'slide';
    const loop = el.dataset.loop === 'true';

    new Swiper(el, {
        direction: 'horizontal',
        loop: loop,
        autoHeight: false,

        effect: effect,

        speed: 300,
        autoplay: {
            delay: delay,
            disableOnInteraction: false,
        },


        // If we need pagination
        pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
            addIcons: false,
        },

    });

});
